import React, { useEffect } from 'react';
import qrlocation from '../assets/img/qrlocation.jpeg';


export default function ContactView() {

  useEffect(() => {
    document.title = "Contact - Jesuit Madurai Province Archives (JEMPARC)";
    window.scrollTo(0, 0);
    document.body.classList.add('contact');
  }, []);

  return (
    <div>
        <section id="contact" className="contact section">

   
      <div className="container section-title" data-aos="fade-up">
        <h2>Contact</h2>
        <p>Contact Us</p>
      </div>

      <div className="container" data-aos="fade" data-aos-delay="100">

        <div className="row gy-4">

          <div className="col-lg-4">
            <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="200">
              <i className="bi bi-geo-alt flex-shrink-0"></i>
              <div>
                <h3>Address</h3>
                <p style={{textAlign:"justify"}}>The Director, <br />
Jesuit Madurai Province Archives, <br />
Sacred Heart College, <br />
Shembaganur, <br />
Kodaikanal - 624 101</p>
              </div>
            </div>

     {/*       <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="300">
              <i className="bi bi-telephone flex-shrink-0"></i>
              <div>
                <h3>Call Us</h3>
                <p>+1 5589 55488 55</p>
              </div>
            </div> */}

            <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="400">
              <i className="bi bi-envelope flex-shrink-0"></i>
              <div>
                <h3>Email Us</h3>
                <p>archivist@mdusj.org</p>
              </div>
            </div>
 {/*<div className="info-item d-flex" data-aos="fade-up" data-aos-delay="200">
              <i className="bi bi-geo-alt flex-shrink-0"></i>
              <div>
                <h3>Address</h3>
                <p style={{textAlign:"justify"}}>Jesuit Madurai Province Archives
Sacred Heart College
Shembaganur
Kodaikanal - 624 101</p>
              </div>
            </div>*/}


            <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="400">
              <i className="bi bi-telephone flex-shrink-0"></i>
              <div>
                <h3>Phone No</h3>
                <p>+91 7448709941</p>
              </div>
            </div>
          </div>

          <div className="col-lg-4">
          {/*}  <form action="forms/contact.php" method="post" className="php-email-form" data-aos="fade-up" data-aos-delay="200">
              <div className="row gy-4">

                <div className="col-md-6">
                  <input type="text" name="name" className="form-control" placeholder="Your Name" required="" />
                </div>

                <div className="col-md-6 ">
                  <input type="email" className="form-control" name="email" placeholder="Your Email" required="" />
                </div>

                <div className="col-md-12">
                  <input type="text" className="form-control" name="subject" placeholder="Subject" required="" />
                </div>

                <div className="col-md-12">
                  <textarea className="form-control" name="message" rows="6" placeholder="Message" required=""></textarea>
                </div>

                <div className="col-md-12 text-center">
                  <div className="loading">Loading</div>
                  <div className="error-message"></div>
                  <div className="sent-message">Your message has been sent. Thank you!</div>

                  <button type="submit">Send Message</button>
                </div>

              </div>
            </form> */}
            <iframe 
  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15705.535554008202!2d77.5009738!3d10.2305902!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xf3dd1af1dddcfd67!2sJesuit+Archives!5e0!3m2!1sen!2sin!4v1491980640690" 
  width="600" 
  height="450" 
  style={{border:0, width: "100%", height: "400px"}}
  allowFullScreen="" 
  loading="lazy" 
  referrerPolicy="no-referrer-when-downgrade">
</iframe>
          </div>
          <div className="col-lg-4">
            <h3>Find Us Here</h3>
            <img src={qrlocation} />
            </div>

        </div>

      </div>

    </section>
    </div>
  )
}
